import { Sector, SectorCreatePayload, SectorUpdatePayload } from '../types';
import { api } from '../../../../core/utils/apiClient';

interface SectorListResponse {
  sectors: Sector[];
  total: number;
}

export class SectorsService {
  async listSectors(activeOnly: boolean = true): Promise<Sector[]> {
    try {
      const response = await api.get(`/api/v1/sectors/?active_only=${activeOnly}`);
      if (response.ok) {
        const data: SectorListResponse = await response.json();
        return data.sectors || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching sectors:', error);
      return [];
    }
  }

  async createSector(payload: SectorCreatePayload): Promise<Sector | null> {
    const response = await api.post('/api/v1/sectors/', payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async updateSector(id: number, payload: SectorUpdatePayload): Promise<Sector | null> {
    const response = await api.put(`/api/v1/sectors/${id}`, payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async deleteSector(id: number): Promise<void> {
    const response = await api.delete(`/api/v1/sectors/${id}`);
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.detail || `HTTP ${response.status}`);
    }
  }
}

export const sectorsService = new SectorsService();
